export default __webpack_public_path__ + "static/media/placeholder_portfolio03-es-web.618a7000.png";